import React from 'react';
import { bonuses } from '../data/salesContent';
export function BonusesSection() {
  return <section className="w-full bg-ink-800 py-16 sm:py-24" aria-labelledby="bonuses-title" style={{
    paddingBottom: "0px",
    paddingTop: "0px"
  }} data-id="element-22" data-mp="gw58rpc513me">
      <div className="mx-auto max-w-4xl px-5" data-id="element-23" data-mp="vuh3vrjv44bg">
        <div className="text-center" data-id="element-24" data-mp="qu30imt7hijr">
          <h2 id="bonuses-title" className="font-display text-3xl font-bold text-white sm:text-[2.75rem]" data-id="element-25" data-mp="qt04k0h10pwz">
            🎁 4 Bonuses — <span className="text-lilac-400" data-id="element-26" data-mp="14rhrvx30s0ed">Always Free</span>
          </h2>
        </div>

        <ul className="mt-12 space-y-4" data-id="element-27" data-mp="zu7unv9e2kfz">
          {bonuses.map(b => <li key={b.index} className="flex items-center gap-5 rounded-2xl border border-white/10 bg-ink-700 p-5 sm:gap-7 sm:p-6" data-id="element-28" data-mp="1ejnjh5pd0ft1">
              <img src={b.image} alt={`${b.title} bonus ebook cover`} className="w-24 shrink-0 rounded-md sm:w-32" width={400} height={520} data-id="element-29" data-mp="19l2slwvzz8h9" />
              <div className="min-w-0" data-id="element-30" data-mp="1jiqmylpoydyw">
                <span className="text-[11px] font-bold uppercase tracking-[0.16em] text-lilac-400" data-id="element-31" data-mp="1jjry0q6pj0gm">
                  Bonus {b.index}
                </span>
                <h3 className="mt-1.5 font-display text-lg font-bold leading-snug text-white sm:text-xl" data-id="element-32" data-mp="3trnirh7e9i9b">
                  {b.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-body" data-id="element-33" data-mp="2k1cdgtaj1or">{b.description}</p>
                <p className="mt-3 text-sm font-bold" data-id="element-34" data-mp="7lic3901gi3r">
                  <span className="text-muted line-through" data-id="element-35" data-mp="ck1tqx7ln7qb">$27</span>{' '}
                  <span className="text-success" data-id="element-36" data-mp="chz7mo9khyqv">→ FREE</span>
                </p>
              </div>
            </li>)}
        </ul>

        <p className="mt-10 text-center font-display text-xl font-bold text-white sm:text-2xl" data-id="element-37" data-mp="lblpdagxx1h2">
          Total bonus value: <span className="text-muted line-through" data-id="element-38" data-mp="qbgizls3o55t">$108</span> →{' '}
          <span className="text-success" data-id="element-39" data-mp="vajm30ois1b5">FREE</span> with your Blueprint
        </p>
      </div>
    </section>;
}